import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';
import { ApiUrls } from '../../apiRouts';
import { MainService } from '../../service/main.service';
import { filter } from 'rxjs';

declare function googleTranslateElementInit(): any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  heading: any;
  iconClass: any;
  user_id: any;
  event_id: any
  notificationListLength: any;
  userId: any;

  @Output() toggleClick: EventEmitter<any> = new EventEmitter();

  constructor(public route: Router, 
    private localStorageService: LocalStorageService,
    private mainService: MainService,
    private router: Router
  ) {
    this.mainService.setProfileData().subscribe((res: any) => {
      if (res == 1) {
        this.getNotificationListLength();
      }
    })
    this.user_id = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;

    this.getNotificationListLength();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.onRouteChange();
      });

    
  }

  onRouteChange() {
    if (this.route.url == '/change-password' || this.route.url == '/auth/change-password') {
      this.heading = 'પાસવર્ડ બદલો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/otp-verification' || this.route.url == '/auth/otp-verification') {
      this.heading = 'OTP  ચકાસો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/forgot-password' || this.route.url == '/auth/forgot-password') {
      this.heading = 'પાસવર્ડ ભૂલી ગયા છો ?';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/sign-up' || this.route.url == '/auth/sign-up') {
      this.heading = 'સાઇન અપ કરો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/committee' || this.route.url == '/committee/committee-members') {
      this.heading = 'સમિતિના સભ્યો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/donor' || this.route.url == '/donor/donor-list') {
      this.heading = 'દાતાઓ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url.includes('memory') || this.route.url == '/memory/memory-list') {
      this.heading = 'યાદગીરી';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/memory/memory-details') {
      this.heading = 'યાદગીરી';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/committee/main-member-list') {
      this.heading = 'કુટુંબના મુખ્ય સભ્યોની યાદી';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/committee/all-member-list') {
      this.heading = 'કુટુંબના બધા સભ્યોની યાદી';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/committee/activist-member') {
      this.heading = 'સભ્યોને કમિટી માં ફેરવો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/committee/activist-member-list/2') {
      this.heading = 'કમિટી સભ્યો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/donor/donor-list/3') {
      this.heading = 'દાતાઓ';
      this.iconClass = 'ti ti-chevron-left';
    }    
    if (this.route.url == '/contact-us') {
      this.heading = 'અમારો સંપર્ક કરો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/about-dhaduk-family') {
      this.heading = 'About Dhaduk Family';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/jobs' || this.route.url == '/jobs/job-list') {
      this.heading = 'નોકરી ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/jobs/job-list/' + this.user_id) {
      this.heading = 'સ્વયં બનાવેલ જોબ પોસ્ટ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/city' || this.route.url == '/city-list') {
      this.heading = 'શહેરો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/city/district-list') {
      this.heading = 'જિલ્લાઓ';
      this.iconClass = 'ti ti-chevron-left';
    }  
    if (this.route.url == '/' || this.route.url.includes('/subdivision')) {
      this.heading = 'તાલુકો';
      this.iconClass = 'ti ti-chevron-left';
    } 
    if (this.route.url == '/' || this.route.url.includes('/village')) {
      this.heading = 'ગામ';
      this.iconClass = 'ti ti-chevron-left';
    }   
    if (this.route.url == '/business' || this.route.url == '/business/business-list') {
      this.heading = 'વ્યવસાય';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/business/business-list' + this.user_id) {
      this.heading = 'સ્વયં બનાવેલ વ્યવસાય પોસ્ટ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/nri-memberlist' || this.route.url == '/NRI/nri-memberlist') {
      this.heading = 'NRI સભ્યો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/master') {
      this.heading = 'Master';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/notification-list') {
      this.heading = 'સૂચનાઓ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/notification') {
      this.heading = 'સૂચનાઓ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url == '/dashboard') {
      this.heading = 'Driver Detection';
      this.iconClass = 'ti ti-category-2';
    }
    if (this.route.url == '/doctor/doctor-list') {
      this.heading = 'ડૉક્ટર';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/doctor-details')) {
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url == '/event') {
      this.heading = 'કાર્યક્રમ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/sub-event')) {
      this.heading = 'પેટા કાર્યક્રમ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/event-donor')) {
      this.heading = 'કાર્યક્રમ દાતાઓ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/add-memory-Folder')) {
      this.heading = 'યાદગીરી ફોલ્ડર ઉમેરો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/contact-list') {
      this.heading = 'સંપર્ક વિગતો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/qr-scanner')) {
      this.heading = 'QR Scanner';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/menunal-invitation-present-member')) {
      this.heading = 'આમંત્રિત સભ્ય';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/' || this.route.url.includes('/add-event-donor')) {
      this.heading = 'Driver Detection';
      this.iconClass = 'ti ti-chevron-left';
    }   
    if (this.route.url == '/user-post' ) {
      this.heading = 'પોસ્ટ';
      this.iconClass = 'ti ti-chevron-left';
    }  
    if (this.route.url == '/user-post/add-user-post' ) {
      this.heading = 'પોસ્ટ ઉમેરો';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/reminder') {
      this.heading = 'સ્મરણ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/reminder/water-reminder') {
      this.heading = 'પાની';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/reminder/sleep-reminder') {
      this.heading = 'ઊંઘ';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/reminder/medicine-reminder') {
      this.heading = 'દવા';
      this.iconClass = 'ti ti-chevron-left';
    }
    if (this.route.url == '/reminder/custom-reminder') {
      this.heading = 'સ્મરણ';
      this.iconClass = 'ti ti-chevron-left';
    }
  }

  getNotificationListLength() {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    if (this.userId != 0 && this.userId != null && this.userId != undefined && this.userId != '') {
      let data = {
        notification_id: 0,
        notification_title: "",
        description: "",
        created_by: 0,
        to_user_type_id: Number(this.localStorageService.getItem('user_id')),
        Action: 'ISREADCOUNT',
      };
      this.mainService.postApi(ApiUrls.addNotification, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.notificationListLength = res.notification.length;
        } else {
          this.notificationListLength = 0;
        } this.mainService.triggerProfileData();
      });
    }
  }
  goBackToPrevPage(): void {
    this.toggleClick.emit(this.route.url == '/' || this.route.url == '/dashboard');
  }

  goToNotificationList() {
    this.route.navigate(['/notification-list']);
    this.heading = 'સૂચનાઓ';
  }
}

